import './App.css';
import './css/ImageGrid.css'
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css"; 
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/home';
import Fashion_tab from './pages/fashion_tab';
import Dailylook_detail from './pages/dailylook_detail';
import Search from './pages/search';
import Layout from './components/Layout';
import Feed_tab from './pages/feed_tab';
import Starapply from './pages/starapply';
import LoginPage from './pages/Loginpage'; // 로그인 페이지
import KakaoRedirect from './components/KakaoRedirect';
import Profile_detail from './pages/profile_detail';
import Mypage from './pages/mypage';
import Recommend_page from './pages/recommend_page';
import Favorite_page from './pages/favorite_page';
import Vote_page from './pages/vote_page';
import Alert_center from './pages/alert_center';
import AccountSetupForm from './pages/AccountSetuppage';
import LayoutNon from './components/Layout_nonNavBar';
import Find_password from './pages/find_password';
import Editprofile from './pages/editprofile';

function App() {
  return (
    // <Router>는 최상위 index.js에 있다고 가정합니다.
    <Routes>
      
      {/* 1. 레이아웃이 없는 독립적인 경로들 */}
      {/* /login 경로는 Layout 컴포넌트의 적용을 받지 않습니다. */}
      <Route path="/" element={<LayoutNon />}>
        <Route path="login" element={<LoginPage />} />
        <Route path="auth" element={<KakaoRedirect />} />
        <Route path="profile" element={<Profile_detail />} />
        <Route path="alert" element={<Alert_center />} />
        <Route path="signup" element={<AccountSetupForm />} />
        <Route path="findpw" element={<Find_password />} />
                <Route path="editprofile" element={<Editprofile />} />
        
        
      </Route>

      
      {/* 2. Layout이 필요한 모든 경로를 감싸는 Wrapper Route */}
      {/* path="/"와 element={<Layout>...</Layout>}을 사용하여 Layout을 Route 처리합니다. */}
      <Route path="/" element={<Layout />}>
        {/* Layout이 필요한 자식 라우트들 */}
        {/* index 속성은 부모 경로("/")와 동일한 경로일 때 렌더링됩니다. */}
        <Route index element={<Home />} /> 
        
        <Route path="dailylook" element={<Dailylook_detail />} />
        
        <Route path="search" element={<Search />} />
        <Route path="rating" element={<Fashion_tab />} />
        <Route path="feed" element={<Feed_tab />} />
        <Route path="event" element={<Starapply />} />
        <Route path="my" element={<Mypage />} />
        <Route path="recommend" element={<Recommend_page />} />
        <Route path="favorite" element={<Favorite_page />} />
        <Route path="vote" element={<Vote_page />} />

        
        

        {/*
          주의: 중첩된 <Route>를 사용할 때,
          자식 경로 (예: "dailylook")는 부모 경로 ("/") 뒤에 상대적으로 붙습니다.
          path="/" 대신 path="dailylook"만 사용해야 합니다.
        */}
      </Route>


    
      
    </Routes>
  );
}

export default App;